var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 53,
    viewBox: "0 0 28 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5386 8L26.5386 44.0381C26.5386 48.1802 23.1807 51.5381 19.0386 51.5381L-0.499514 51.5381L-0.499512 0.5L19.0386 0.500001C23.1807 0.500003 26.5386 3.85787 26.5386 8Z",
    fill: "#001023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5386 8L26.5386 44.0381C26.5386 48.1802 23.1807 51.5381 19.0386 51.5381L-0.499514 51.5381L-0.499512 0.5L19.0386 0.500001C23.1807 0.500003 26.5386 3.85787 26.5386 8Z",
    stroke: "#4A5463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5095 21.0144L10.5192 26.024L15.5288 31.0144",
    stroke: "#CDD5DF",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderCollapse);
export default __webpack_public_path__ + "static/media/slider-collapse.8f7981ff59e5d9d7a0157e5392b1d8b2.svg";
export { ForwardRef as ReactComponent };